import React from "react";
import Slider from "../components/sliderhome";
import Carouselteam from "../components/carouselteam";
import Bannercontact from "../components/bannercontact";
import Pricing from "../components/pricing";
import Testimony from "../components/carouseltestimony";
import Footer from "../components/footer";

export default () => (
  <div>
    <section className="jumbotron jumbomain">
      <Slider />
      <div className="icon-scroll-wraper">
        <div className="icon-scroll">
          <div className="icon-scroll-screen"></div>
        </div>
      </div>
    </section>

    <section className="container-fluid p-0">
      <div className="row">
        <div className="col-md-4 p-0">
          <div className="features">
            <div className="bg">
              <img src="./img/witalyconceptdesign.png" alt="bg-features" />
            </div>
            <div className="content">
              <div className="heading">Concept Design</div>
              <div className="con-text">
                We offer a comprehensive range of interior design services,
                including concept development, space planning, material
                selection, and project management.
              </div>
              {/* <div className='link'>
                  <span className="shine"></span>
                  Read More
                </div> */}
            </div>
          </div>
        </div>

        <div className="col-md-4 p-0">
          <div className="features">
            <div className="bg">
              <img src="./img/witalyarchitectureimage.png" alt="bg-features" />
            </div>
            <div className="content">
              <div className="heading">Interior</div>
              <div className="con-text">
                Best in class interior design services that transform spaces
                into functional and aesthetically pleasing environments.
              </div>
              {/* <div className='link'>
                  <span className="shine"></span>
                  Read More
                </div> */}
            </div>
          </div>
        </div>

        <div className="col-md-4 p-0">
          <div className="features">
            <div className="bg">
              <img src="./img/witalyInterior.jpg" alt="bg-features" />
            </div>
            <div className="content">
              <div className="heading">Architecture</div>
              <div className="con-text">
                Witaly Group offers comprehensive architectural design services that
                create innovative and sustainable buildings that meet our clients'
                needs and exceed their expectations.
              </div>
              {/* <div className='link'>
                  <span className="shine"></span>
                  Read More
                </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="container-fluid black pb-0">
      <div className="row m-10-hor">
        <div className="col-md-5">
          <div className="heading">
            {/* why <span className='br'></span>choose<span className='br'></span> us? */}
            Why Choose Us?
          </div>
        </div>

        <div className="col-md-7">
          <div className="content">
            We are a team of experienced professionals dedicated to providing
            exceptional i nterior design services. Our goal is to create
            beautiful, functional spaces that exceed our clients' expectations.
          </div>
          <div className="content">
            Exeptional customer service, attention to detail, and a commitment
            to quality are at the core of our values.
          </div>
        </div>
      </div>
    </section>

    <section className="container-fluid pt-0 black">
      <div className="row m-10-hor">
        <div className="col-md-4 mt-5">
          <div className="col-feature">
            <div className="sub-color text-gradient">01.</div>
            <div className="heading">LUXURY VILLAS</div>
            <div className="content">
              Wide range of villa design services, including concept
              development, space planning, material selection, and project
              management.
            </div>
          </div>
        </div>

        <div className="col-md-4 mt-5">
          <div className="col-feature">
            <div className="sub-color text-gradient">02.</div>
            <div className="heading">RESORT & ECO LODGE</div>
            <div className="content">
              Resort and eco lodge design services that create sustainable and
              luxurious hospitality spaces, blending seamlessly with their
              natural surroundings.
            </div>
          </div>
        </div>

        <div className="col-md-4 mt-5">
          <div className="col-feature">
            <div className="sub-color text-gradient">03.</div>
            <div className="heading">LUXURY HOTELS</div>
            <div className="content">
              From concept to completion, we provide comprehensive swimming pool
              design services that create stunning and functional outdoor
              spaces.
            </div>
          </div>
        </div>

        {/* <div className='col-md-4 mt-5'>
          <div className='col-feature'>
            <div className='sub-color text-gradient'>
              04.
            </div>
            <div className='heading'>
              EXPERT DEVELOPER
            </div>
            <div className='content'>
              Curabitur mollis bibendum luctus. 
              Duis suscipit vitae dui sed suscipit. 
              Vestibulum auctor nunc vitae lectus.
            </div>
          </div>
         </div> */}

        {/* <div className='col-md-4 mt-5'>
          <div className='col-feature'>
            <div className='sub-color text-gradient'>
              05.
            </div>
            <div className='heading'>
              COMPLIANCE SOLUTION
            </div>
            <div className='content'>
              Curabitur mollis bibendum luctus. 
              Duis suscipit vitae dui sed suscipit. 
              Vestibulum auctor nunc vitae lectus.
            </div>
          </div>
         </div> */}

        <div className="col-md-4 mt-5">
          <div className="col-feature">
            <div className="sub-color text-gradient">04.</div>
            <div className="heading">RESTAURANTS</div>
            <div className="content">
              We offer comprehensive restaurant design services that create unique and inviting dining spaces,
              blending functionality with aesthetic appeal to enhance the overall dining experience.
            </div>
          </div>
        </div>
      </div>
    </section>

    <Testimony />
    <Footer />
  </div>
);
